(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-variant-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-filter-nav]').forEach(function (nav) {
    var sectionId = nav.getAttribute('data-filter-nav');
    var grid = document.querySelector('[data-grid="' + sectionId + '"]');
    if (!grid) return;

    var cards = grid.querySelectorAll('.color-variant-card');
    var boxes = nav.querySelectorAll('.color-variant-filter-box');

    nav.addEventListener('click', function (event) {
      var box = event.target.closest('.color-variant-filter-box');
      if (!box) return;

      boxes.forEach(function (b) {
        b.classList.remove('is-active');
      });
      box.classList.add('is-active');

      var value = box.getAttribute('data-filter-value');

      cards.forEach(function (card) {
        if (value === 'all') {
          card.classList.remove('is-hidden-by-filter');
          return;
        }
        var tags = (card.getAttribute('data-tags') || '').split('|');
        if (tags.indexOf(value) !== -1) {
          card.classList.remove('is-hidden-by-filter');
        } else {
          card.classList.add('is-hidden-by-filter');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
